import {useCallback, useEffect, useRef, useState} from 'react'
import {
    SortingState,
    flexRender,
    getCoreRowModel,
    getFilteredRowModel,
    getSortedRowModel,
    useReactTable,
} from '@tanstack/react-table'
import React from 'react'
import notifyToast from '../../components/Toast/Toast'
import {KTCard, KTCardBody} from '../../../_websoft/helpers'
import {ToastContainer} from 'react-toastify'
import TableSearch from '../../components/TableSearch/TableSearch'
import ExportButton from '../../components/TableExportToExcel/ExportButton'
import LoadingComponent from '../../components/LoadingComponent/LoadingComponent'
import TablePagination from '../../components/TablePagination/TablePagination'
import {PaginationModel} from '../../models/PaginationModel'
import {ParamsModelTable, ThermoBoardPaketiModel} from '../../models/ThermoBoardPaketi'
import {getAllTBPaketi} from '../../api/thermoBoardPaketi'
import IndeterminateCheckbox from '../../components/IndeterminateCheckbox/IndeterminateCheckbox'
import MinMaxFilter from '../../components/MinMaxFilter/MinMaxFilter'
import UpdateStatusComponent from './UpdateStatusComponent'
import moment from 'moment'

const STATUS_COLUMN_ID = 'Status'
const PROIZVEDENO_COLUMN_ID = 'Proizvedeno'
const ISPORUCENO_COLUMN_ID = 'Isporuceno'

const ThermoBoardPaketi: React.FC = () => {
    const [data, setData] = useState<ThermoBoardPaketiModel[]>([])
    const [loading, setLoading] = useState(false)
    const [rowSelection, setRowSelection] = useState({})
    const [pagination, setpagination] = useState<PaginationModel>({
        curPage: 1,
        totalPage: 1,
        perPage: 10,
    })

    const [params, setparams] = useState<ParamsModelTable>({per_page: 10, page: 1})

    const [sorting, setSorting] = useState<SortingState>([])
    const [globalFilter, setGlobalFilter] = React.useState('')
    const [idNaloga, setidNaloga] = useState<string>()
    const [proizvedeno, setProizvedeno] = useState<string>('')
    const [isporuceno, setIsporuceno] = useState<string>('')

    const [paketiBlok, setPaketBlok] = useState(false)
    const inputRef = useRef<HTMLInputElement>(null)

    const statusCodes: { [key: string]: [string, string] } = {
        0: ['Isporučen', '#FFFFFF'],
        1: ['Raspoloživ', '#53F55A'],
        2: ['Rezervisan', '#FF4C44'],
    }
    const getStatusCode = (status: string | number) => statusCodes[String(status)]
    const isActiveValue = (value: string | number) => String(value) === '1'

    const getBooleanCellColor = (value: string | number) =>
        isActiveValue(value) ? '#E8FFF3' : '#FFF5F8'

    const getCellColor = (cell, row) => {
        if (cell.column.id === STATUS_COLUMN_ID) {
            return getStatusCode(row.original.Status)?.[1] ?? '#FFFFFF'
        }

        if (cell.column.id === PROIZVEDENO_COLUMN_ID) {
            return getBooleanCellColor(row.original.Proizvedeno)
        }

        if (cell.column.id === ISPORUCENO_COLUMN_ID) {
            return getBooleanCellColor(row.original.Isporuceno)
        }

        return '#FFFFFF'
    }
    const columns = [
        {
            id: '#',
            header: ({table}) => (
                <div className='p-2' style={{width: '10px'}}>
                    {' '}
                    {/* Set width here */}
                    <IndeterminateCheckbox
                        {...{
                            checked: table.getIsAllRowsSelected(),
                            indeterminate: table.getIsSomeRowsSelected(),
                            onChange: table.getToggleAllRowsSelectedHandler(),
                        }}
                    />
                </div>
            ),
            cell: ({row, getValue}) => (
                <div className='p-2' style={{width: '10px'}}>
                    {' '}
                    {/* Set width here */}
                    <IndeterminateCheckbox
                        {...{
                            checked: row.getIsSelected(),
                            indeterminate: row.getIsSomeSelected(),
                            onChange: row.getToggleSelectedHandler(),
                        }}
                    />
                </div>
            ),
        },
        {
            id: 'Paket',
            header: 'Paket',
            accessorKey: 'Id',
        },

        {
            id: 'Tip Panela',
            header: 'Tip Panela',
            accessorKey: 'nalozi.tip_panela.Naziv',
        },
        {
            id: 'Kupac',
            header: 'Kupac',
            accessorKey: 'Kupac',
        },
        {
            id: 'Širina',
            header: 'Širina',
            accessorKey: 'Sirina',
        },
        {
            id: 'Dužina',
            header: 'Dužina',
            accessorKey: 'Duzina',
        },
        {
            id: 'Kom.',
            header: 'Kom.',
            accessorKey: 'Komada',
        },
        {
            id: PROIZVEDENO_COLUMN_ID,
            header: 'Proizvedeno',
            accessorKey: 'Proizvedeno',
            cell: ({row}) => (
                <span
                    className={`badge ${
                        isActiveValue(row.original.Proizvedeno) ? 'badge-light-success' : 'badge-light-danger'
                    }`}
                >
          {isActiveValue(row.original.Proizvedeno) ? 'DA' : 'NE'}
        </span>
            ),
        },
        {
            id: 'Datum',
            header: 'Datum proizvodnje',
            cell: ({ row }) =>
                row.original.ProizvedenDatum
                    ? moment(row.original.ProizvedenDatum).format('DD-MM-YYYY')
                    : '-',
        },
        {
            id: ISPORUCENO_COLUMN_ID,
            header: 'Isporučeno',
            accessorKey: 'Isporuceno',
            cell: ({row}) => (
                <span
                    className={`badge ${
                        isActiveValue(row.original.Isporuceno) ? 'badge-light-success' : 'badge-light-danger'
                    }`}
                >
          {isActiveValue(row.original.Isporuceno) ? 'DA' : 'NE'}
        </span>
            ),
        },
        {
            id: 'Datum',
            header: 'Isporučeno Datum',
            cell: ({ row }) =>
                row.original.DatumIsporuke
                    ? moment(row.original.DatumIsporuke).format('DD-MM-YYYY')
                    : '-',
        },
        {
            id: 'Komercijalista',
            header: 'Komercijalista',
            accessorKey: 'nalog.Komercijalista',
        },
        {
            header: 'Tip paketa',
            accessorKey: 'nalozi.TipPaketa',
            cell: ({row}) => (
                <div
                    style={{
                        color: row.original.nalozi.TipPaketa === 1 ? 'green' : 'red',
                    }}
                >
                    {row.original.nalozi.TipPaketa === 1 ? 'MEGA' : 'OBIČAN'}
                </div>
            ),
        },
        {
            id: STATUS_COLUMN_ID,
            header: 'Status',
            accessorKey: 'Status',
            cell: ({row}) => getStatusCode(row.original.Status)?.[0] ?? row.original.Status,
        },
    ]
    const table = useReactTable({
        data: data,
        columns,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        state: {
            sorting: sorting,
            globalFilter: globalFilter,
            rowSelection,
        },
        onGlobalFilterChange: setGlobalFilter,
        getFilteredRowModel: getFilteredRowModel(),
        onSortingChange: setSorting,
        enableRowSelection: true, //enable row selection for all rows
        onRowSelectionChange: setRowSelection,
    })

    const showPaketi = useCallback(
        (requestParams = params) => {
            if (!idNaloga) {
                notifyToast(false, 'Unesite Id naloga.')
                return
            }

            setLoading(true)

            const apiParams = {
                ...requestParams,
                idNaloga: idNaloga,
                ...(proizvedeno !== '' ? {Proizvedeno: proizvedeno} : {}),
                ...(isporuceno !== '' ? {Isporuceno: isporuceno} : {}),
            }

            getAllTBPaketi(apiParams as any)
                .then((response) => {
                    const data = response.data['data']
                    setData(data)
                    const totalPage = Math.max(
                        Math.ceil(response.data['total'] / response.data['per_page']),
                        1
                    )
                    setpagination({
                        curPage: response.data['current_page'],
                        totalPage: totalPage,
                        perPage: requestParams.per_page,
                    })
                })
                .catch((error) => {
                    console.error('Error: ', error)
                    notifyToast(false, error)
                })
                .finally(() => {
                    setLoading(false)
                    setPaketBlok(true)
                })
        },
        [idNaloga, isporuceno, params, proizvedeno]
    )

    useEffect(() => {
        if (paketiBlok) {
            showPaketi(params)
        }
    }, [paketiBlok, params, showPaketi])

    return (
        <KTCard>
            <ToastContainer/>
            <KTCardBody className='py-4'>
                {!paketiBlok && (
                    <div className='rounded border bg-light p-5 mb-6'>
                        <div className='d-flex flex-column flex-lg-row justify-content-between gap-4 mb-5'>
                            <div>
                                <h2 className='fw-bold fs-3 text-gray-900 mb-1'>Pretraga paketa</h2>
                                <div className='text-muted fw-semibold fs-7'>
                                    Unesite Id naloga. Statusi su opcioni filteri.
                                </div>
                            </div>
                        </div>

                        <div className='row g-4 align-items-end'>
                            <div className='col-12 col-lg-4 col-xl-3'>
                                <label className='form-label required fw-bold fs-6'>Id naloga</label>
                                <input
                                    type='text'
                                    placeholder='Unesite Id naloga'
                                    className='form-control form-control-lg form-control-solid'
                                    ref={inputRef}
                                    value={idNaloga ?? ''}
                                    onChange={(e) => setidNaloga(e.target.value)}
                                    disabled={loading}
                                />
                            </div>
                            <div className='col-12 col-md-6 col-lg-3 col-xl-2'>
                                <label className='form-label fw-bold fs-6'>Proizvedeno</label>
                                <select
                                    className='form-select form-select-lg form-select-solid'
                                    value={proizvedeno}
                                    onChange={(e) => setProizvedeno(e.target.value)}
                                    disabled={loading}
                                >
                                    <option value=''>Odaberi</option>
                                    <option value='1'>Da</option>
                                    <option value='0'>Ne</option>
                                </select>
                            </div>
                            <div className='col-12 col-md-6 col-lg-3 col-xl-2'>
                                <label className='form-label fw-bold fs-6'>Isporuceno</label>
                                <select
                                    className='form-select form-select-lg form-select-solid'
                                    value={isporuceno}
                                    onChange={(e) => setIsporuceno(e.target.value)}
                                    disabled={loading}
                                >
                                    <option value=''>Odaberi</option>
                                    <option value='1'>Da</option>
                                    <option value='0'>Ne</option>
                                </select>
                            </div>
                            <div className='col-12 col-lg-auto'>
                                <button
                                    type='button'
                                    className='btn btn-primary btn-lg fw-bold px-8 w-100'
                                    onClick={() => {
                                        if (!idNaloga) {
                                            notifyToast(false, 'Unesite Id naloga.')
                                            return
                                        }

                                        const firstPageParams = {...params, page: 1}
                                        setparams(firstPageParams)
                                        setPaketBlok(true)
                                    }}
                                    disabled={loading}
                                >
                                    {!loading && 'Prikazi pakete'}
                                    {loading && (
                                        <span className='indicator-progress' style={{display: 'block'}}>
                                            Ucitavanje...
                                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                        </span>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                {paketiBlok && <UpdateStatusComponent table={table} update={showPaketi}/>}
                <div className='separator mt-2 mb-4'></div>
                <div className='d-flex justify-content-between'>
                    <div data-kt-user-table-toolbar='base'>
                        <TableSearch onSearch={(text) => setGlobalFilter(text)}/>
                    </div>
                    <div data-kt-user-table-toolbar='base'>
                        <ExportButton table={table} filename={'thermoboard_paketi'}/>
                    </div>
                </div>

                {loading ? (
                    <LoadingComponent/>
                ) : (
                    <div className='table-responsive mt-3 '>
                        <table className='table table-bordered gy-5 no-footer'>
                            <thead>
                            {table.getHeaderGroups().map((headerGroup) => (
                                <tr
                                    key={headerGroup.id}
                                    className='text-start fw-bolder fs-7 text-uppercase gs-0 bg-dark p-2'
                                >
                                    {headerGroup.headers.map((header) => (
                                        <th className='text-white' key={header.id}>
                        <span onClick={header.column.getToggleSortingHandler()}>
                          {flexRender(header.column.columnDef.header, header.getContext())}
                            {/* @ts-ignore */}
                            {{asc: '🔼', desc: '🔽'}[header.column.getIsSorted() ?? null]}
                        </span>
                                            {header.column.getCanFilter() ? (
                                                <div>
                                                    {header.column.id === 'sirina' && (
                                                        <MinMaxFilter
                                                            minMaxValues={(min, max) => {
                                                                table.setColumnFilters([
                                                                    {
                                                                        id: 'sirina',
                                                                        value: [min, max],
                                                                    },
                                                                ])
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            ) : null}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                            </thead>
                            <tbody className='text-gray-600'>
                            {table.getRowModel().rows && table.getRowModel().rows.length > 0 ? (
                                table.getRowModel().rows.map((row) => (
                                    <tr key={row.id}>
                                        {row.getVisibleCells().map((cell) => (
                                            <td
                                                key={cell.id}
                                                style={{
                                                    backgroundColor: getCellColor(cell, row),
                                                }}
                                            >
                                                {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={7}>
                                        <div
                                            className='d-flex text-center w-100 align-content-center justify-content-center'>
                                            No matching records found
                                        </div>
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                )}
                <TablePagination
                    updatePage={(page, per_page) =>
                        setparams((prev) => ({...prev, page: page, per_page: per_page}))
                    }
                    pagination={pagination}
                />
            </KTCardBody>
        </KTCard>
    )
}
export default ThermoBoardPaketi
